import React from "react";
import clsx from 'clsx';
import "../CalibrageEnCours/evaluationCard.css"
import iconChat from "../../../assets/images/icon-chat.svg";
import { Avatar } from "@mui/material";
import {
    OverlayTrigger,
    Tooltip,
  } from "react-bootstrap";
import iconLike from "../../../assets/images/like-icon.png";
import iconDislike from "../../../assets/images/dislike-icon.png";
import {Tooltip as MuiTooltip} from "@mui/material"
const EvaluationComparedCard = (props) => {
  function format(inputDate) {
    let date, month, year;

    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();

    date = date.toString().padStart(2, "0");

    month = month.toString().padStart(2, "0");

    return `${date}/${month}/${year}`;
  }
  return (
          <div className={props.isSelected ? "card eval-card-active" : "card eval-card"} key={props.key}>
          <div className="evaluator-container-comparaison">
          <div className="section-evaluator">
                <span className="section-names"> Evalué </span>
                <div className="container-evaluator">
                  <Avatar
                    alt={"JL"}
                    sx={{ bgcolor: "#5800E2" }}
                    
                    className="bordered-img-evaluator"
                    sizes="2"
                  >
                    {props.evaluation.agent.firstName?.charAt(0)?.toUpperCase()}
                    {props.evaluation.agent.lastName?.charAt(0)?.toUpperCase()}
                  </Avatar>
                  <div className="name-evaluator">
                    <span className="section-subnames_evaluateur">
                      {" "}                    
                      {props.evaluation.agent.firstName}
                      {" "}
                      {props.evaluation.agent.lastName}
                    </span>
                  </div>
                </div>
               </div>
              
            <div className="container-score-calibrage" >
              <span style={{ fontFamily: "Gilroy-Semibold", color: "#B7B7B7" }}>
                {" "}
                Score Total :
              </span>
              <span className="detail-eval_score">
                {" "}
                {props.evaluation?.note}
                /100{" "}
              </span>
            </div>
        </div>
        <hr />
        <div className="evaluator-container-comparaison">
          <div className="section-evaluator">
                <span className="section-names"> Évaluateur </span>
                <div className="container-evaluator">
                  <Avatar
                    alt={"JL"}
                    sx={{ bgcolor: "#5800E2" }}
                    className="bordered-img-evaluator"
                    sizes="2"
                  >
                    {props.evaluation.evaluateur.firstName?.charAt(0)?.toUpperCase()}
                    {props.evaluation.evaluateur.lastName?.charAt(0)?.toUpperCase()}
                  </Avatar>
                  <div className="name-evaluator">
                    <span className="section-subnames_evaluateur">
                      {" "}                    
                      {props.evaluation.evaluateur.firstName}
                      {" "}
                      {props.evaluation.evaluateur.lastName}
                    </span>
                    <span className="section-subnames_evaluateur-title">
                      {" "}
                      {props.evaluation.evaluateur.role.name}{" "}
                    </span>
                  </div>
                </div>
               </div>
        </div>
        <hr/>
        <div style={{ paddingLeft: 0, height: "100%", marginTop: "10px" , minWidth : "330px"}}>
            <div className="container-info-eval-right-side">
              {props.grille &&
                props.grille?.CriteriaGroup?.map(
                  (e) =>
                    props.CriteriaGroup[e.name] &&
                    props.CriteriaGroup[e.name].length && (
                      <div className="container-relationnel-eval-card">
                        <div className="header-relationnel-eval-calib">
                          <span className="header-relationnel_text-eval-calib">
                            {" "}
                            {e.name}
                          </span>
                          <span className="score-grp-eval-calib">
                            {" "}
                            {props.evaluation?.ScoreGroupCriteriaEval.filter(
                (score) => score.GroupCriteriaId === e.id
              ).map((filteredScore) => filteredScore.score)}
                              {" "}
                          </span>
                        </div>
                        
                        {props.CriteriaGroup[e.name] &&
                          props.CriteriaGroup[e.name].length &&
                          props.CriteriaGroup[e.name].slice().sort((a, b) => a.Criteria.id - b.Criteria.id).map((e1, key) => (
                            <div style={{minHeight: "85px"}} key={e1.Criteria.id}>
                            <div className="attribute-relationnel-eval-card">
                           <MuiTooltip title={e1?.Criteria.name.length > 15 ? e1.Criteria.name : ""}
                            arrow
                            key={e1.Criteria.id}>
                            <span>{e1?.Criteria.name.length > 15  ? `${e1.Criteria.name.substring(0, 15)}...`: e1.Criteria.name}</span>
                            </MuiTooltip>
                              <div
                                className="d-flex flex-column align-items-center "
                                style={{ gap: 5 }}
                              >
                                <span
                                  style={{
                                    fontFamily: "Gilroy",
                                    fontSize: "small",
                                    color: `${e1.color}`,
                                  }}
                                >
                                  {e1.value}
                                </span>
                                <div
                                  className="bar"
                                  style={{ backgroundColor: `${e1.color}` }}
                                >
                                </div>
                              </div>
                              <div className="row right-icons-eval" > 
                                <div className="col margin-left-right">
                                <div>
                                  {e1.CriteriaOptions && e1.CriteriaOptions.filter((cr)=>cr.type==="BONUS").length > 0 ? (
                                    <div className="flex-space-between container-cercle-like">
                                    {e1.CriteriaOptions.filter((cr)=> cr.type ==="BONUS").length}
                                    </div>
                                  ) : null}
                                    <OverlayTrigger
                                    delay={{ show: 250, hide: 400 }}
                                    rootClose
                                    placement="bottom-end"
                                    overlay={<Tooltip>
                                      {e1.CriteriaOptions.filter((cr)=> cr.type ==="BONUS").map((cr)=> 
                                         <div
                                         className={clsx("container-bonus-malus-eval", {
                                           "container-bonus-malus-on":
                                           true,
                                         })}
                                         >
                                           {cr.name}
                                         </div>)}
                                       </Tooltip>}                                    >
                                       <img
                                        className="img-Info-position2"
                                        width={20}
                                        alt=""
                                        src={iconLike}
                                      />
                                    </OverlayTrigger>
                                  </div> 
                                  </div>
                                  <div className="col margin-left-right">
                                  <div>
                                  {e1.CriteriaOptions && e1.CriteriaOptions.filter((cr)=>cr.type==="MALUS").length > 0 ? (
                                    <div className="container-cercle-dislike">
                                    {e1.CriteriaOptions.filter((cr)=> cr.type ==="MALUS").length}
                                    </div>
                                  ) : null}
                                    <OverlayTrigger
                                    delay={{ show: 250, hide: 400 }}
                                    rootClose
                                    placement="bottom-end"
                                    overlay={<Tooltip>
                                     {e1?.CriteriaOptions?.filter((cr)=> cr?.type ==="MALUS").map((cr)=> 
                                        <div
                                        className={clsx("container-bonus-malus-eval", {
                                          "container-bonus-malus-on":
                                          true,
                                        })}
                                        >
                                          {cr?.name}
                                        </div>)}
                                      </Tooltip>}
                                    >
                                       <img
                                        className="img-Info-position2"
                                        width={20}
                                        alt=""
                                        src={iconDislike}
                                      />
                                    </OverlayTrigger>
                                  </div> 
                                  </div>
                                  <div className="col margin-left-right">
                                  {e1.comment ? (
                                    <>
                                    <div className="container-cercle-like">
                                      1
                                    </div>
                                      <OverlayTrigger
                                      rootClose
                                      placement="bottom-end"
                                      overlay={
                                        <Tooltip>
                                        <div className="comment-section" >
                                          {e1.comment}
                                        </div>
                                         </Tooltip>
                                         }
                                        >
                                      <img
                                        className="img-chat-position1"
                                        width={32}
                                        src={iconChat}
                                        alt=""
                                      />
                                    </OverlayTrigger>
                                    </>
                                    ) :  <img
                                    className="img-chat-position1"
                                    width={32}
                                    src={iconChat}
                                    alt=""
                                  />
                                  }
                              </div>
                                  </div>
                            
                            </div>
                            </div>
                          ))}
                      </div>
                    )
                )}
            </div>
          </div>
      </div>

)
};
export default EvaluationComparedCard;
